import { Component, ViewChild, AfterViewInit, Output, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { SubSink } from 'subsink';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../app.reducers';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Workspace } from 'app/internal/shared';
import { CustomValidators } from 'app/shared';
import { SpUtilities } from '../../../../shared/services/utilities';
import { ClearNotificationsAction } from '../../../../shared/redux/global/global.actions';
import { CreateAdminPortfolioAction } from '../../admin-store/admin.actions';

@Component({
  selector: 'sp-admin-add-portfolio',
  templateUrl: './admin-add-portfolio.component.html',
  styleUrls: ['./admin-add-portfolio.component.scss'],
  standalone: false
})
export class AdminAddPortfolioComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(ModalDirective, { static: true }) public bsModal: ModalDirective;
  @Output() close = new EventEmitter<void>();
  @Output() added = new EventEmitter<void>();
  
  isSubmitting = false;
  formGroup: UntypedFormGroup;
  states: Array<string>;
  private subs = new SubSink();

  constructor(private fb: UntypedFormBuilder,
    private store: Store<AppState>,
    private utils: SpUtilities) {
  }

  ngOnInit() {
    this.states = this.utils.getStates();
    this.initForm();
  }

  ngAfterViewInit() {
    this.bsModal.config.keyboard = false;
    this.bsModal.config.ignoreBackdropClick = true;

    this.subs.sink = this.bsModal.onHide
      .subscribe(() => {
        this.resetForm();
        this.close.next();
      });
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  private initForm() {

    this.formGroup = this.fb.group({});
    this.formGroup.addControl(
      'portfolioName',
      this.fb.control('',
        [
          Validators.required,
        ])
    );
    this.formGroup.addControl(
      'companyName',
      this.fb.control('',
        [
          Validators.required,
        ])
    );

    this.formGroup.addControl(
      'address',
      this.fb.control('',
        [
          //Validators.required,
        ])
    );

    this.formGroup.addControl(
      'address2',
      this.fb.control('',
        [
          //Validators.required,
        ])
    );

    this.formGroup.addControl(
      'city',
      this.fb.control('',
        [
          //Validators.required,
        ])
    );

    this.formGroup.addControl(
      'state',
      this.fb.control('',
        [
          //Validators.required,
        ])
    );

    this.formGroup.addControl(
      'zip',
      this.fb.control('',
        [
          //Validators.required,
          CustomValidators.zipcodeValidator
        ])
    );

    this.formGroup.addControl(
      'contactName',
      this.fb.control('',
        [
          //Validators.required,
        ])
    );

    this.formGroup.addControl(
      'email',
      this.fb.control('',
        [
          //Validators.required,
          CustomValidators.emailValidator
        ])
    );

    this.formGroup.addControl(
      'phone',
      this.fb.control('',
        [
          //Validators.required,
          //CustomValidators.stringLegnthValidator(10, 15)
        ])
    );

    this.formGroup.addControl(
      'website',
      this.fb.control('',
        [
          //Validators.required,
        ])
    );

    this.formGroup.addControl(
      'whiteLabelSwitch',
      this.fb.control(false,
        [
          Validators.required,
        ])
    );

    this.formGroup.addControl(
      'loanAnalysisSwitch',
      this.fb.control(false,
        [
          Validators.required,
        ])
    );

    this.formGroup.addControl(
      'featureTogglePreventativeMaintenance',
      this.fb.control(false,
        [
          Validators.required,
        ])
    );
  }

  show() {
    this.bsModal.show();
  }

  onSaveAndDone() {
    this.bsModal.hide();
    this.added.next();
  }

  cancel() {
    this.bsModal.hide();
  }

  private onSubmit() {

    const controls = this.formGroup.controls;

    this.store.dispatch(new ClearNotificationsAction());

    const portfolio = <Workspace>{};
    portfolio.name = controls['portfolioName'].value;
    portfolio.companyName = controls['companyName'].value;
    portfolio.address1 = controls['address'].value;
    portfolio.address2 = controls['address2'].value;
    portfolio.city = controls['city'].value;
    portfolio.state = controls['state'].value;
    portfolio.zipCode = controls['zip'].value;
    portfolio.contactName = controls['contactName'].value;
    portfolio.contactEmail = controls['email'].value;
    portfolio.phone = controls['phone'].value;
    portfolio.website = controls['website'].value;
    portfolio.isPrivateLabel = controls['whiteLabelSwitch'].value;
    portfolio.featureToggleLoanAnalysis = controls['loanAnalysisSwitch'].value;
    portfolio.featureTogglePreventativeMaintenance = controls['featureTogglePreventativeMaintenance'].value;

    this.store.dispatch(new CreateAdminPortfolioAction(portfolio));
  }

  addPortfolio() {
    this.added.emit();
    this.isSubmitting = true;
    this.onSubmit();
    this.isSubmitting = false;
    this.onSaveAndDone();
  }

  private resetForm() {
    const controls = this.formGroup.controls;

    this.formGroup.reset();

    controls['whiteLabelSwitch'].setValue(false);
    controls['featureTogglePreventativeMaintenance'].setValue(false);
    controls['loanAnalysisSwitch'].setValue(false);
  }
}
